import SamlServiceProviderListView from "./SamlServiceProviderListView";

export { SamlServiceProviderListView };
